import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const reorderLots = (resource, id, lotIds) => {
  return axios.put(`/api/${resource}/${id}/setup/lots/order`, { lot_ids: lotIds });
};

export const useReorderLots = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (lotIds) => reorderLots(resource, id, lotIds),
    onSuccess: () => {
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
